import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    shareholderDividendHistories: [],
    shareholderDividendHistory: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.shareholderDividendHistories = [];
      state.shareholderDividendHistory = null;
    },
    SET_SHAREHOLDER_DIVIDEND_HISTORIES(state, data) {
      state.shareholderDividendHistories = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SHAREHOLDER_DIVIDEND_HISTORY(state, data) {
      state.shareholderDividendHistory = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setShareholderDividendHistory({ commit }, data) {
      commit('SET_SHAREHOLDER_DIVIDEND_HISTORY', data);
    },

    find({ commit, state }) {
      let url = `/shareholder_dividend_histories?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SHAREHOLDER_DIVIDEND_HISTORIES', response);
        });
    },

    findById({ commit }, id) {
      return http(`/shareholder_dividend_histories/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_SHAREHOLDER_DIVIDEND_HISTORY', item);
        });
    },

    destroy(_, id) {
      return http(`/shareholder_dividend_histories/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/shareholder_dividend_histories/${id}`, { method: 'PUT', data })
        : http('/shareholder_dividend_histories', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
